module.exports = require("react-redux");


/*****************
 ** WEBPACK FOOTER
 ** external "react-redux"
 ** module id = 30
 ** module chunks = 0
 **/